import { Box, FormControl, Grid, InputLabel, MenuItem, Paper, Select, SelectChangeEvent } from "@mui/material"
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { LinearProgress } from "@mui/material";
import { FormHandles } from "@unform/core";
import * as yup from 'yup';


import { AlertSnackBar, AutoCompleteDeCliente, FerramentaDeDetalhe } from "../../shared/components";
import { LayoutBaseDePagina } from "../../shared/layouts";
import { VTextField, VForm, useVForm } from "../../shared/forms";
import { IndiceService } from "../../shared/services/api/indice/IndiceService";
import { Environment } from "../../shared/environment";
import { TipoDeCaixa_Service } from "../../shared/services/api/tipo_de_caixa/TipoDeCaixa_Service";
import { DialogConfirm } from "../../shared/components/dialog/DialogConfirm";

interface IFormData {
    idTipoCaixa: number,
    nomeTipo: string,
}

interface IFormDataValidation {
    nomeTipo: string,
}

const formValidationSchema: yup.SchemaOf<IFormDataValidation> = yup.object().shape({
    nomeTipo: yup.string().required("O nome do tipo de caixa é obrigatório"),
});

export const DetalheDeTipoDeCaixa: React.FC = () => {

    const { idTipo_de_caixa = 'novo' } = useParams<'idTipo_de_caixa'>();
    const navigate = useNavigate();

    const { formRef, save, saveAndReturn, isSaveAndReturn } = useVForm();

    const [cnpj, setCnpj] = useState<string | undefined | null>(undefined);

    const [alertSnackbar, setAlertSnackbar] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
    const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

    const [isLoading, setIsLoading] = useState(false);
    const [nomeTitulo, setNomeTitulo] = useState('');

    useEffect(() => {
        if (idTipo_de_caixa !== 'novo') {

            setIsLoading(true);
            setNomeTitulo("Carregando...");

            TipoDeCaixa_Service.getById(Number(idTipo_de_caixa)).then((result) => {
                setIsLoading(false);
                if (result instanceof Error) {

                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);

                } else {
                    setNomeTitulo(result.nomeTipo);
                    formRef.current?.setData(result);
                }
            });

        } else {
            limparCampos();
        }
    }, [idTipo_de_caixa])

    useEffect(() => {
        if (localStorage.getItem("cnpj") === "" || localStorage.getItem("cnpj") === null || localStorage.getItem("cnpj") === undefined) {
            navigate('/tipo_de_caixa')
        }
        setCnpj(localStorage.getItem("cnpj"));
    })

    const handleSave = (dados: IFormData) => {
        formValidationSchema.validate(dados, { abortEarly: false }).then(() => {
            if (idTipo_de_caixa === 'novo') {
                if (cnpj !== null && cnpj !== undefined && cnpj !== "") {

                    setIsLoading(true);
                    TipoDeCaixa_Service.create(dados).then((result) => {
                        setIsLoading(false);
                        if (result instanceof Error) {

                            setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);

                        } else {

                            setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Tipo de caixa cadastrado com sucesso" });
                            setTimeout(() => {
                                setAlertSnackbar(undefined);
                            }, duracaoAlert);

                            TipoDeCaixa_Service.create_TipoCaixa_Cliente(result, cnpj).then((resultRelacao) => {
                                setIsLoading(false);
                                if (resultRelacao instanceof Error) {

                                    setAlertSnackbar({ tipoAlert: "erro", mensagem: resultRelacao.message });
                                    setTimeout(() => {
                                        setAlertSnackbar(undefined);
                                    }, duracaoAlert);

                                } else {

                                    setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Tipo de caixa associado com sucesso" });
                                    setTimeout(() => {
                                        setAlertSnackbar(undefined);
                                    }, duracaoAlert);

                                }
                            })

                            if (isSaveAndReturn()) {
                                navigate('/tipo_de_caixa');
                            } else {
                                limparCampos();
                            }

                        }
                    });
                } else {

                    setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Nenhum cliente selecionado" });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);

                }

            } else {
                dados.idTipoCaixa = Number(idTipo_de_caixa);
                setIsLoading(true);
                TipoDeCaixa_Service.updateById(dados).then((result) => {
                    setIsLoading(false);
                    if (result instanceof Error) {

                        setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                        setTimeout(() => {
                            setAlertSnackbar(undefined);
                        }, duracaoAlert);

                    } else {

                        setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Tipo de caixa alterado com sucesso" });
                        setTimeout(() => {
                            setAlertSnackbar(undefined);
                        }, duracaoAlert);

                        if (isSaveAndReturn()) {
                            navigate('/tipo_de_caixa');
                        }

                        setNomeTitulo(dados.nomeTipo);

                    }
                });
            }
        }).catch((errors: yup.ValidationError) => {
            const validationErrors: { [key: string]: string } = {};

            errors.inner.forEach(error => {
                if (!error.path) return;

                validationErrors[error.path] = error.message;
            });

            formRef.current?.setErrors(validationErrors);
            setIsLoading(false);

        });
    }
    const handleDelete = () => {

        setIsLoading(true);
        TipoDeCaixa_Service.toggleEnabledById(Number(idTipo_de_caixa)).then((result) => {

            setIsLoading(false);

            if (result instanceof Error) {//verificar se deu erro

                setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);

            } else {

                setAlertSnackbar({ tipoAlert: "sucess", mensagem: "Tipo de caixa desativado com sucesso" });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
                navigate('/tipo_de_caixa');

            }
        }
        )
    }

    const limparCampos = () => {
        formRef.current?.setData({
            nomeTipo: ''
        });
    }
    const [abrir, setAbrir] = useState(false);

    const handleCancel = () => {
        setAbrir(false);
    }



    return (
        <LayoutBaseDePagina
            titulo={idTipo_de_caixa == 'novo' ? 'Novo Tipo de Caixa' : nomeTitulo}
            barraDeFerramentas={
                <FerramentaDeDetalhe
                    mostrarBotaoSalvarEVoltar
                    mostrarBotaoApagar={idTipo_de_caixa !== 'novo'}
                    mostrarBotaoNovo={idTipo_de_caixa !== 'novo'}

                    mostrarBotaoNovoCarregando={isLoading}
                    mostrarBotaoApagarCarregando={isLoading}
                    mostrarBotaoSalvarCarregando={isLoading}
                    mostrarBotaoSalvarEVoltarCarregando={isLoading}

                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEVoltar={saveAndReturn}
                    aoClicarEmApagar={() => setAbrir(true)}
                    aoClicarEmNovo={() => navigate('/tipo_de_caixa/detalhe/novo')}
                    aoClicarEmVoltar={() => navigate('/tipo_de_caixa')}
                />
            }
        >
            {isLoading && (
                <LinearProgress variant="indeterminate" />
            )}

            <DialogConfirm
                AoConfirmar={handleDelete}
                titulo={"Dejesa realmente desativar o tipo de caixa?"}
                texto={"Ao confirmar, ao confirmar o tipo de caixa será desativado e será necessário reativa-lo para poder usar novamente."}
                abrir={abrir}
                AoCancelar={handleCancel}
            />

            {alertSnackbar !== undefined && (
                <>
                    {alertSnackbar.tipoAlert === "sucesso" && (
                        <AlertSnackBar gravidade="success" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alertSnackbar.tipoAlert === "erro" && (
                        <AlertSnackBar gravidade="error" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alertSnackbar.tipoAlert === "aviso" && (
                        <AlertSnackBar gravidade="warning" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                </>
            )}

            <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">

                <VForm ref={formRef} onSubmit={handleSave}>
                    <Grid container direction="column" padding={2} spacing={2}>

                        <Grid container item direction="row" spacing={2}>

                            <Grid item xs={12} sm={8} md={6} lg={4}>
                                <VTextField fullWidth label="Nome" placeholder="Digite o nome..." name="nomeTipo" disabled={isLoading} />
                            </Grid>

                        </Grid>

                    </Grid>
                </VForm>

            </Box>


        </LayoutBaseDePagina>
    );
}